module.exports = __webpack_public_path__ + "static/media/Image2.4544a11d.png";